/**
 * Input Schema of Endereco
 * @author Simpli CLI generator
 */
import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {slice} from 'lodash'

/* TODO: review generated schema */
export class InputEnderecoSchema extends Schema {
  readonly name = 'InputEndereco'

  get secondaryFields() {
    return slice(this.allFields, 1)
  }

  get responsavelFields() {
    return ['logradouro', 'bairro', 'cidade', 'uf']
  }

  readonly fieldSet: FieldSet<Endereco> = {
    cep: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'zipcode',
        label: this.translateFrom(schema.fieldName),
        validation: 'cep',
      },
      on: {
        input: () => {
          if (schema.model.cep?.length === 8) {
            $.await.run(`populateEnderecoFromCEP`, () =>
              schema.model.populateFromCEP()
            )
          }
        },
      },
    }),
    logradouro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    nro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 45,
        label: this.translateFrom(schema.fieldName),
      },
    }),

    bairro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    cidade: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    uf: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        inputClass: 'uppercase',
        type: 'text',
        maxlength: 2,
        required: true,
        label: this.translateFrom(schema.fieldName),
        validation: 'required',
      },
    }),
    pais: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        validation: 'required',
      },
    }),
    complemento: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        validation: 'required',
      },
    }),
  }
}
